import { Box } from '@betterment/samba-react';
import { PlaceholderAreaChart, BalanceChart as SharedBalanceChart } from '@betterment/shared-components';
import { ParentSize } from '@visx/responsive';

import { UserBalancePerformanceQuery } from './graphql/userPerformanceBalance.generated';

export type BalanceChartProps = {
  history: UserBalancePerformanceQuery['performance']['history'] | undefined;
  balanceDetailsId: string;
  loading: boolean;
};

export const BalanceChart: React.FC<BalanceChartProps> = ({ history, balanceDetailsId, loading = true }) => {
  return (
    <Box>
      <ParentSize debounceTime={10}>
        {({ width }) =>
          !loading && history && history.timeSeries.length > 0 ? (
            <SharedBalanceChart
              data={history.timeSeries}
              width={width}
              height={350}
              aria-describedby={balanceDetailsId}
              aria-label="Balance Chart"
            />
          ) : (
            <PlaceholderAreaChart
              width={width}
              height={350}
              variant={loading || !history ? 'loading' : 'empty'}
              aria-describedby={balanceDetailsId}
              aria-label={!history ? 'Loading chart' : 'No data available'}
            />
          )
        }
      </ParentSize>
    </Box>
  );
};
